import { useState } from 'react';
import { Link } from 'react-router-dom';
import { resendVerification, signupUser } from '../API';

const Signup = () => {
  const [formData, setFormData] = useState({
    email: '',
    prenom: '',
    nom: '',
    password: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [claimHint, setClaimHint] = useState(false);
  const [unverifiedHint, setUnverifiedHint] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendMessage, setResendMessage] = useState('');

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleResend = async () => {
    setResendMessage('');
    setResendLoading(true);

    try {
      const response = await resendVerification({ email: formData.email });
      setResendMessage(response.message);
    } catch (err) {
      setError(err.message);
    } finally {
      setResendLoading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');
    setClaimHint(false);
    setUnverifiedHint(false);
    setResendMessage('');

    if (formData.password !== formData.confirmPassword) {
      setError('Les mots de passe ne correspondent pas.');
      return;
    }

    if (formData.password.length < 8) {
      setError('Le mot de passe doit contenir au moins 8 caractères.');
      return;
    }

    setLoading(true);

    try {
      const response = await signupUser({
        email: formData.email,
        prenom: formData.prenom,
        nom: formData.nom,
        password: formData.password,
      });
      setSuccess(response.message);
    } catch (err) {
      setError(err.message);
      if (err.code === 'GOOGLE_ACCOUNT_CLAIMABLE') {
        setClaimHint(true);
      }
      if (err.code === 'EMAIL_NOT_VERIFIED') {
        setUnverifiedHint(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container pt-4">
      <div className="container-fluid col-sm-8 col-lg-6">
        <div className="jumbotron mt-2">
          <h1 className="display-4">Créer un compte</h1>

          {success ? (
            <>
              <div className="alert alert-success" role="alert">
                {success}
              </div>
              <p className="mb-0">
                Cliquez sur le lien reçu pour activer votre compte, puis connectez-vous.
              </p>
            </>
          ) : (
            <>
              <p className="lead">Inscrivez-vous avec votre courriel pour accéder à Medcodes.</p>

              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                  {claimHint && (
                    <p className="mb-0 mt-2">
                      <Link to={`/claim-account?email=${encodeURIComponent(formData.email)}`}>
                        Activer votre compte Google existant
                      </Link>
                    </p>
                  )}
                  {unverifiedHint && (
                    <p className="mb-0 mt-2">
                      <button
                        type="button"
                        className="btn btn-link p-0 align-baseline"
                        onClick={handleResend}
                        disabled={resendLoading || !formData.email}
                      >
                        {resendLoading ? 'Envoi...' : 'Renvoyer le courriel de vérification'}
                      </button>
                    </p>
                  )}
                </div>
              )}

              {resendMessage && (
                <div className="alert alert-success" role="alert">
                  {resendMessage}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email">Courriel</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="prenom">Prénom</label>
                  <input
                    type="text"
                    className="form-control"
                    id="prenom"
                    name="prenom"
                    value={formData.prenom}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="nom">Nom</label>
                  <input
                    type="text"
                    className="form-control"
                    id="nom"
                    name="nom"
                    value={formData.nom}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="password">Mot de passe</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    minLength={8}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="confirmPassword">Confirmer le mot de passe</label>
                  <input
                    type="password"
                    className="form-control"
                    id="confirmPassword"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    minLength={8}
                    required
                  />
                </div>

                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Création...' : 'Créer mon compte'}
                </button>
              </form>
            </>
          )}

          <p className="mt-3 mb-0">
            Déjà un compte? <Link to="/login">Se connecter</Link>
          </p>
          <p className="mt-2 mb-0">
            Compte Google existant? <Link to="/claim-account">Activer votre compte</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Signup;
